"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const JavaScriptObfuscatorCLIFacade_1 = require("./src/JavaScriptObfuscatorCLIFacade");
module.exports = JavaScriptObfuscatorCLIFacade_1.JavaScriptObfuscatorCLI;
